import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { listProvinceApi, listMunicipalityApi, listRegionApi, listComarcaApi, listCountryApi } from "../../../../services/Admin/geografia";
export default function BillingInformation(props) {
    const {
        formik,
        defaultRegionInvoiceValueList,
        defaultProvinceInvoiceValueList,
        defaultMunicipioInvoiceValueList,
        defaultComarcaInvoiceValueList,
        defaultCountryInvoiceValueList,

        setDefaultRegionInvoiceValueList,
        setDefaultProvinceInvoiceValueList,
        setDefaultMunicipioInvoiceValueList,
        setDefaultComarcaInvoiceValueList,
        setDefaultCountryInvoiceValueList,
    } = props

    const [listMunicipalityAll, setListMunicipalityAll] = useState([]);

    const [listProvince, setListProvince] = useState([])

    const [listRegion, setListRegion] = useState([])

    const [listComarca, setListComarca] = useState([])

    const [listCountry, setListCountry] = useState([])

    useEffect(() => {
        getMunicipality()
        getProvince()
        getRegion()
        getComarca()
        getCountry()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setDefaultMunicipioInvoiceValueList(defaultMunicipioInvoiceValueList)
    }, [defaultMunicipioInvoiceValueList])

    useEffect(() => {
        setDefaultProvinceInvoiceValueList(defaultProvinceInvoiceValueList)
    }, [defaultProvinceInvoiceValueList])

    useEffect(() => {
        setDefaultRegionInvoiceValueList(defaultRegionInvoiceValueList)
    }, [defaultRegionInvoiceValueList])

    useEffect(() => {
        setDefaultComarcaInvoiceValueList(defaultComarcaInvoiceValueList)
    }, [defaultComarcaInvoiceValueList])

    useEffect(() => {
        setDefaultCountryInvoiceValueList(defaultCountryInvoiceValueList)
    }, [defaultCountryInvoiceValueList])

    const getRegion = async () => {
        listRegionApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListRegion(temp)
        })
    }

    const getMunicipality = async () => {
        listMunicipalityApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListMunicipalityAll(temp)
        })
    }

    const getProvince = async () => {
        listProvinceApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListProvince(temp)
        })
    }

    const getComarca = async () => {
        listComarcaApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListComarca(temp)
        })
    }

    const getCountry = async () => {
        listCountryApi().then(resp => {
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map((doc) => ({
                    id: doc.id,
                    ...doc,
                }))
            setListCountry(temp)
        })
    }

    // limpiar provincia y municipio si la región cambia y no corresponden
    useEffect(() => {
        if (
            formik.values.idRegionInvoice &&
            defaultProvinceInvoiceValueList &&
            defaultProvinceInvoiceValueList.idRegion !== formik.values.idRegionInvoice.id
        ) {
            setDefaultProvinceInvoiceValueList({});
            formik.values.idProvinceInvoice = null;
            setDefaultMunicipioInvoiceValueList({});
            formik.values.idMunicipalityInvoice = null;
        }
        // limpiar región si no corresponde
        if (
            formik.values.idRegionInvoice &&
            defaultRegionInvoiceValueList &&
            defaultRegionInvoiceValueList.id !== formik.values.idRegionInvoice.id
        ) {
            setDefaultRegionInvoiceValueList({});
        }
    }, [formik.values.idRegionInvoice]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // Cuando cambia la provincia, limpia el municipio si no corresponde
        if (
            defaultMunicipioInvoiceValueList &&
            defaultMunicipioInvoiceValueList.idProvince !== defaultProvinceInvoiceValueList.id
        ) {
            setDefaultMunicipioInvoiceValueList({});
            formik.values.idMunicipalityInvoice = null;
        }
    }, [defaultProvinceInvoiceValueList]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box border={1} className="p-20 box-default">
            <Grid container spacing={3}>
                <Grid item md={6}>
                    <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                        <div>
                            <h4 className="p-0 mt-0">Datos de facturación</h4>
                        </div>
                        <div>
                            <TextField
                                variant="outlined"
                                label="* DNI/CIF"
                                className="form-control"
                                name="dni"
                                type="text"
                                value={formik.values.dni || ""}
                                onChange={formik.handleChange}
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                            {formik.errors.dni ? (
                                <p className="text-100 text-danger mt-1">
                                    {formik.errors.dni}
                                </p>
                            ) : null}
                        </div>

                        <div>
                            <TextField
                                variant="outlined"
                                label="* Telefono"
                                className="form-control"
                                name="phone"
                                type="text"
                                value={formik.values.phone}
                                onChange={formik.handleChange}
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                            {formik.errors.phone ? (
                                <p className="text-100 text-danger mt-1">
                                    {formik.errors.phone}
                                </p>
                            ) : null}
                        </div>

                        <div style={{ marginTop: "8px" }}>
                            <TextField
                                variant="outlined"
                                label="* Razón social / Nombre del cliente"
                                className="form-control"
                                name="invRazonSocial"
                                type="text"
                                value={formik.values.invRazonSocial || ""}
                                onChange={formik.handleChange}
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                            {formik.errors.invRazonSocial && (
                                <p className="text-100 text-danger mt-1">
                                    {formik.errors.invRazonSocial}
                                </p>
                            )}
                        </div>

                        <div style={{ fmarginTop: 20 }}>
                            <FormControl fullWidth size="small" variant="outlined">
                                <InputLabel shrink htmlFor="idCountryInvoice">
                                    * País
                                </InputLabel>
                                <Select
                                    label="* País"
                                    name="idCountryInvoice"
                                    id="idCountryInvoice"
                                    value={formik.values.idCountryInvoice?.id || ""}
                                    onChange={e => {
                                        const country = listCountry.find(c => c.id === e.target.value) || null;
                                        formik.values.idCountryInvoice = country;
                                        setDefaultCountryInvoiceValueList(country || {});

                                        formik.values.idRegionInvoice = null;
                                        setDefaultRegionInvoiceValueList({});

                                        formik.values.idProvinceInvoice = null;
                                        setDefaultProvinceInvoiceValueList({});

                                        formik.values.idMunicipalityInvoice = null;
                                        setDefaultMunicipioInvoiceValueList({});
                                        
                                        formik.values.idComarcaInvoice = null;
                                        setDefaultComarcaInvoiceValueList({});
                                    }}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        <em>Seleccione un país</em>
                                    </MenuItem>
                                    {listCountry.map(country => (
                                        <MenuItem key={country.id} value={country.id}>{country.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {formik.errors.idCountryInvoice && (
                                <p className="text-100 text-danger mt-1">
                                    {formik.errors.idCountryInvoice}
                                </p>
                            )}
                        </div>

                        <div style={{ display: "flex", gap: 10 }}>
                            <div style={{ flex: 1 }}>
                                <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idCountryInvoice?.id}>
                                    <InputLabel shrink htmlFor="idRegionInvoice">
                                        * Comunidad
                                    </InputLabel>
                                    <Select
                                        label="* Comunidad"
                                        name="idRegionInvoice"
                                        id="idRegionInvoice"
                                        value={formik.values.idRegionInvoice?.id || ""}
                                        onChange={e => {
                                            const region = listRegion.find(r => r.id === e.target.value) || null;
                                            formik.values.idRegionInvoice = region;
                                            setDefaultRegionInvoiceValueList(region || {});
                                            formik.values.idProvinceInvoice = null;
                                            setDefaultProvinceInvoiceValueList({});
                                            formik.values.idMunicipalityInvoice = null;
                                            setDefaultMunicipioInvoiceValueList({});
                                            formik.values.idComarcaInvoice = null;
                                            setDefaultComarcaInvoiceValueList({});
                                        }}
                                        displayEmpty
                                    >
                                        <MenuItem value="">
                                            <em>Seleccione una comunidad</em>
                                        </MenuItem>
                                        {listRegion
                                            .filter(r => formik.values.idCountryInvoice?.id ? r.idCountry === formik.values.idCountryInvoice.id : true)
                                            .map(region => (
                                            <MenuItem key={region.id} value={region.id}>{region.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {formik.errors.idRegionInvoice && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idRegionInvoice}
                                    </p>
                                )}
                            </div>
                            <div style={{ flex: 1 }}>
                                <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idRegionInvoice?.id}>
                                    <InputLabel shrink htmlFor="idProvinceInvoice">
                                        * Provincia
                                    </InputLabel>
                                    <Select
                                        label="* Provincia"
                                        name="idProvinceInvoice"
                                        id="idProvinceInvoice"
                                        value={formik.values.idProvinceInvoice?.id || ""}
                                        onChange={e => {
                                            const province = listProvince
                                                .filter(p => formik.values.idRegionInvoice?.id ? p.idRegion === formik.values.idRegionInvoice.id : true)
                                                .find(p => p.id === e.target.value) || null;
                                            formik.values.idProvinceInvoice = province;
                                            setDefaultProvinceInvoiceValueList(province || {});
                                            formik.values.idMunicipalityInvoice = null;
                                            setDefaultMunicipioInvoiceValueList({});
                                            formik.values.idComarcaInvoice = null;
                                            setDefaultComarcaInvoiceValueList({});
                                        }}
                                        displayEmpty
                                    >
                                        <MenuItem value="">
                                            <em>Seleccione una provincia</em>
                                        </MenuItem>
                                        {listProvince
                                            .filter(p => formik.values.idRegionInvoice?.id ? p.idRegion === formik.values.idRegionInvoice.id : true)
                                            .map(province => (
                                                <MenuItem key={province.id} value={province.id}>{province.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                {formik.errors.idProvinceInvoice && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idProvinceInvoice}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div style={{ display: "flex", gap: 10 }}>
                            <div style={{ flex: 1 }}>
                                <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idProvinceInvoice?.id}>
                                    <InputLabel shrink htmlFor="idComarcaInvoice">
                                        * Comarca
                                    </InputLabel>
                                    <Select
                                        label="* Comarca"
                                        name="idComarcaInvoice"
                                        id="idComarcaInvoice"
                                        value={formik.values.idComarcaInvoice?.id || ""}
                                        onChange={e => {
                                            const comarca = listComarca
                                                .filter(c => formik.values.idProvinceInvoice?.id ? c.idProvince === formik.values.idProvinceInvoice.id : true)
                                                .find(c => c.id === e.target.value) || null;
                                            formik.values.idComarcaInvoice = comarca;
                                            setDefaultComarcaInvoiceValueList(comarca || {});
                                            formik.values.idMunicipalityInvoice = null;
                                            setDefaultMunicipioInvoiceValueList({});
                                        }}
                                        displayEmpty
                                    >
                                        <MenuItem value="">
                                            <em>Seleccione una comarca</em>
                                        </MenuItem>
                                        {listComarca
                                            .filter(c => formik.values.idProvinceInvoice?.id ? c.idProvince === formik.values.idProvinceInvoice.id : true)
                                            .map(comarca => (
                                                <MenuItem key={comarca.id} value={comarca.id}>{comarca.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                {formik.errors.idComarcaInvoice && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idComarcaInvoice}
                                    </p>
                                )}
                            </div>
                            <div style={{ flex: 1 }}>
                                <FormControl fullWidth size="small" variant="outlined" disabled={!formik.values.idComarcaInvoice?.id}>
                                    <InputLabel shrink htmlFor="idMunicipalityInvoice">
                                        * Población
                                    </InputLabel>
                                    <Select
                                        label="* Población"
                                        name="idMunicipalityInvoice"
                                        id="idMunicipalityInvoice"
                                        value={formik.values.idMunicipalityInvoice?.id || ""}
                                        onChange={e => {
                                            const municipio = listMunicipalityAll
                                                .filter(m => formik.values.idProvinceInvoice?.id ? m.idProvince === formik.values.idProvinceInvoice.id : true)
                                                .find(m => m.id === e.target.value) || null;
                                            formik.values.idMunicipalityInvoice = municipio;
                                            setDefaultMunicipioInvoiceValueList(municipio || {});
                                        }}
                                        displayEmpty
                                    >
                                        <MenuItem value="">
                                            <em>Seleccione una población</em>
                                        </MenuItem>
                                        {listMunicipalityAll
                                            .filter(m => formik.values.idProvinceInvoice?.id ? m.idProvince === formik.values.idProvinceInvoice.id : true)
                                            .map(municipio => (
                                                <MenuItem key={municipio.id} value={municipio.id}>{municipio.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                {formik.errors.idMunicipalityInvoice && (
                                    <p className="text-100 text-danger mt-1">
                                        {formik.errors.idMunicipalityInvoice}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid item md={6}>
                    <div style={{ gap: "10px", display: "flex", flexDirection: "column" }}>
                        <div>
                            <h4 className="p-0 mt-0">&nbsp;</h4>
                        </div>
                        <div>
                            <TextField
                                name="invAddress"
                                label="* Dirección"
                                multiline
                                rows={4}
                                variant="outlined"
                                fullWidth
                                size="small"
                                value={formik.values.invAddress || ""}
                                onChange={formik.handleChange}
                                InputLabelProps={{ shrink: true }}
                            />


                            {formik.errors.invAddress && (
                                <p className="text-100 text-danger mt-1">
                                    {formik.errors.invAddress}
                                </p>
                            )}
                        </div>
                        <div style={{ marginTop: "5px" }}>
                            <TextField
                                variant="outlined"
                                label="* Código postal"
                                className="form-control"
                                name="invCp"
                                type="text"
                                value={formik.values.invCp}
                                onChange={formik.handleChange}
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />
                            {formik.errors.invCp && (
                                <p className="text-100 text-danger mt-1">
                                    {formik.errors.invCp}
                                </p>
                            )}
                        </div>

                        <div>
                            <TextField
                                variant="outlined"
                                label="* Email Facturacion"
                                className="form-control"
                                name="emailFacturacion"
                                type="text"
                                value={formik.values.emailFacturacion || ""}
                                onChange={formik.handleChange}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                size="small"
                            />
                            {formik.errors.emailFacturacion && (
                                <p className="text-100 text-danger mt-1">
                                    {formik.errors.emailFacturacion}
                                </p>
                            )}
                        </div>

                        <div style={{ display: "flex" }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formik.values.facturacionAutomatica || ""}
                                        onChange={formik.handleChange}
                                        name="facturacionAutomatica"
                                        color="primary"
                                    />
                                }
                                label="Facturación automática"
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formik.values.mostrarPrecioFactura || ""}
                                        onChange={formik.handleChange}
                                        name="mostrarPrecioFactura"
                                        color="primary"
                                    />
                                }
                                label="Mostrar precio en las líneas de la factura"
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Box>
    )
}
